import { ReactElement, useState } from 'react';
import { isEmpty } from '@client/common/utils/empty/empty';
import { useUserData } from '@client/context/hooks';
import { useUpdateNewslettersAction, useUpdateNewslettersData } from '@client/myAccount/newsletters/hooks';
import { RequestNewslettersType } from 'b2b-common/core/account/api/Newsletters.types';
import { UpdateForm } from './UpdateForm';
import { FormValuesType, Props } from './UpdateFormContainer.types';

export const UpdateFormContainer = ({ onNewslettersUpdated, newslettersData }: Props): ReactElement => {
  const { profile } = useUserData();
  const updateNewsletters = useUpdateNewslettersAction();
  const [wereCheckboxesChanged, setWereCheckboxesChanged] = useState(false);
  const updateNewslettersRecord = useUpdateNewslettersData();

  const handleSubmit = (values: FormValuesType): void => {
    const { activeSubscriber, personalized = {}, general = {} } = values;
    let allNewsletters = { ...personalized };

    Object.entries(general).forEach(([_language, newsletters]) => {
      if (!isEmpty(newsletters)) {
        allNewsletters = { ...allNewsletters, ...newsletters };
      }
    });

    const subscriptions = (
      !isEmpty(allNewsletters) ? { subscriptions: allNewsletters } : {}
    );

    updateNewsletters({ ...subscriptions, activeSubscriber } as RequestNewslettersType);
    onNewslettersUpdated();
    setWereCheckboxesChanged(false);
  };

  const handleCheckboxChange = (): void => {
    setWereCheckboxesChanged(true);
  };

  const handleActiveSubscriberChange = (): void => {
    handleCheckboxChange();
  };

  return (
    <UpdateForm
      newslettersData={newslettersData}
      updateNewslettersRecord={updateNewslettersRecord}
      email={profile ? profile.email : ''}
      onActiveSubscriberChange={handleActiveSubscriberChange}
      onCheckboxChange={handleCheckboxChange}
      onSubmit={handleSubmit}
      wereCheckboxesChanged={wereCheckboxesChanged}
    />
  );
};
